import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import { useAppDispatch, useAppSelector } from "../../utils/hooks";
import { useTheme } from "../../context/ThemeProvider";
import EmptyChatScreen from "./Chat/EmptyChatScreen";
import MessageList from "./MessageList/MessageList";
import OnClickOutside from "../../utils/OnClickOutSide";
import Bottombar from "./Bottombar";
import { useEffect } from "react";
import { updateViewState } from "../../store/Slices/ViewManagerSlice";
import ReusableModal from "./MessageList/ReusableModal";
import ReturnToCallBar from "./VideoCall/ReturnToCallBar";

export default function Home() {
  const currentConversationData = useAppSelector(
    (state) => state.CurrentConversation,
  );
  const ViewManager = useAppSelector((state) => state.ViewManager);
  const peerCallId = useAppSelector((state) => state.PeerJsSlice.call_id);
  const callJoined = useAppSelector((state) => state.PeerJsSlice.call_joined);
  const ssCallId =
    typeof window !== "undefined"
      ? Number(sessionStorage.getItem("call_id") || 0)
      : 0;
  // Only after Accept / outbound dial — not while ringing modal is open
  const callActive = !!(peerCallId || ssCallId) && callJoined;

  const { theme } = useTheme();
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (currentConversationData.chat_id > 0) {
      // alert("CurrentConversationData");
      dispatch(
        updateViewState({
          show_chats_sidebar: false,
        }),
      );
    }
  }, [currentConversationData]);

  return (
    <>
      {/* <div>Home</div> */}
      <div className="relative flex w-screen">
        <Sidebar />
        <div
          className={`fixed left-0 z-10 w-full transition-all duration-500 lg:relative lg:min-h-max lg:w-[25rem] lg:min-w-[25rem] lg:max-w-[25rem] lg:transition-none 2xl:w-[28rem] 2xl:min-w-[28rem] 2xl:max-w-[28rem] ${ViewManager.show_chats_sidebar ? "translate-x-0" : "-translate-x-[100%] lg:translate-x-0"}`}
        >
          <Outlet />
        </div>
        <div
          className="grid h-[100dvh] max-h-[100dvh] w-full pb-[calc(3.25rem+env(safe-area-inset-bottom))] lg:pb-0"
          style={{
            backgroundImage: `url(${"/Home/chat_background_image.png"})`,
          }}
        >
          <div
            className={`${
              theme == "dark" ? "bg-[#1D1D1D]" : "bg-[#FAFAFA]"
            } relative flex h-full min-h-0 flex-col bg-opacity-[0.98]`}
          >
            {/* Above chat header — stable across conversation switches */}
            {callActive && <ReturnToCallBar variant="embedded" />}
            {/* Mobile chat-list covers the message pane — keep strip visible */}
            {callActive && ViewManager.show_chats_sidebar ? (
              <div className="lg:hidden">
                <ReturnToCallBar variant="floating" />
              </div>
            ) : null}
            <OnClickOutside
              className="flex min-h-0 flex-1 flex-col"
              onClickOutside={() => {
                // dispatch(updateMessageOptions({ selectMessage: false }));
              }}
            >
              {currentConversationData.chat_id == -1 &&
              currentConversationData.user_id == 0 ? (
                <EmptyChatScreen />
              ) : (
                <MessageList />
              )}
            </OnClickOutside>
          </div>
        </div>
      </div>
      <Bottombar />
      {/* Global confirm modal (clear/delete chat works even without open chat) */}
      <ReusableModal />
    </>
  );
}
